import { JobFormManager } from 'jobs/job-form';
import { JobApiService } from 'jobs/JobApiService';
import { JobCountry, JobLocality } from 'jobs/types';
import {
   action,
   computed,
   makeObservable,
   observable,
   runInAction,
} from 'mobx';
export class JobLocationViewModel {
   readonly cities = observable.array<JobLocality>([], { deep: true });
   citiesLoading = false;
   private citySearchRequestSeq = 0;

   constructor(public readonly jobManager: JobFormManager) {
      makeObservable(this, {
         citiesLoading: observable,
         countries: computed,
         cityOptions: computed,
         onCountrySelect: action.bound,
         onCitySelect: action.bound,
         clearCitySelection: action.bound,
      });
   }

   onCountrySelect(countryId: string): void {
      this.jobManager.form.controls['country'].setValue(countryId);
      this.clearCitySelection();
      this.cities.clear();
   }

   onCitySelect(city: JobLocality): void {
      this.jobManager.form.controls['city'].setValue(city.id.toString());
   }

   clearCitySelection(): void {
      this.jobManager.form.controls['city'].setValue('');
   }

   async searchCities(query: string): Promise<void> {
      const countryId = this.jobManager.form.controls['country'].value;

      if (!countryId) {
         this.citySearchRequestSeq += 1;
         runInAction(() => {
            this.cities.clear();
            this.citiesLoading = false;
         });
         return;
      }

      const requestSeq = ++this.citySearchRequestSeq;
      runInAction(() => {
         this.citiesLoading = true;
      });

      try {
         const res = await JobApiService.localitySearch({
            query,
            country_id: Number(countryId),
         });

         if (res.status === 200 && requestSeq === this.citySearchRequestSeq) {
            runInAction(() => {
               this.cities.replace(res.response);
            });
         }
      } catch {
         if (requestSeq === this.citySearchRequestSeq) {
            runInAction(() => {
               this.cities.clear();
            });
         }
      } finally {
         if (requestSeq === this.citySearchRequestSeq) {
            runInAction(() => {
               this.citiesLoading = false;
            });
         }
      }
   }

   get countries(): JobCountry[] {
      const jobAttr = this.jobManager.jobAttributes.get();
      if (jobAttr) {
         return jobAttr.countries;
      }
      return [];
   }

   get cityOptions(): JobLocality[] {
      return this.cities.slice();
   }

   dispose(): void {}
}
